import { GET_ONE, CREATE } from 'react-admin';

const dataTripNotes = (instance, type, params) => {
  const opt = {};
  const fleetId = localStorage.getItem('fleetID');
  const context = params.context || 'BILLING';
  const isOngoingTrip = context === 'ONGOING_TRIP';

  switch (type) {
    case GET_ONE: {
      if (isOngoingTrip) {
        opt.url = `/business/fleets/${fleetId}/ongoingTrip/${params.id}/notes`;
      } else {
        opt.url = `/business/fleets/${fleetId}/trip/${params.id}`;
      }
      opt.method = 'GET';
      break;
    }
    case CREATE: {
      opt.url = `/business/fleets/${fleetId}/trip/${params.id}/notes`;
      opt.method = 'POST';
      opt.data = params.data;
      break;
    }
    default:
      throw new Error(`Unsupported Data Provider request type ${type}`);
  }
  return instance(opt);
};

export default dataTripNotes;
